import { notFound } from '@tanstack/react-router';
import { z } from 'zod';

import { positiveIntParamSchema, projectIdParams } from '../routeParams';

/** Same shape as the neighbouring T360 routes: a malformed id is a 404, not a crash. */
export const documentParams = {
    parse: (raw: { projectId: string; documentId: string }) => {
        const documentId = positiveIntParamSchema.safeParse(raw.documentId);
        if (!documentId.success) throw notFound();
        return {
            ...projectIdParams.parse(raw),
            documentId: documentId.data,
        };
    },
    stringify: (params: { projectId: number; documentId: number }) => ({
        ...projectIdParams.stringify(params),
        documentId: String(params.documentId),
    }),
};

/**
 * The router JSON-parses search values, so `?q=2024` arrives as a number and
 * `?q=true` as a boolean: each is read back as the text it was. A bad value degrades to the default rather than
 * failing the page.
 */
export const documentSearchSchema = z.object({
    page: positiveIntParamSchema.optional().catch(undefined),
    q: z
        .union([z.string(), z.number(), z.boolean(), z.null()])
        .transform((value) => String(value).trim())
        .optional()
        .catch(undefined),
});
